var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProgramLibrary = function SvgProgramLibrary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.95 7.278 11.89 5.17c-.305-.607-.457-.91-.685-1.132a1.902 1.902 0 0 0-.71-.436c-.3-.103-.642-.103-1.324-.103H5.54c-1.064 0-1.596 0-2.003.206-.357.181-.648.47-.83.825-.207.404-.207.933-.207 1.991v.756m0 0h14.44c1.596 0 2.394 0 3.004.309.536.271.972.705 1.245 1.238.311.606.311 1.4.311 2.986v4.156c0 1.586 0 2.38-.31 2.986-.274.533-.71.966-1.246 1.238-.61.309-1.408.309-3.004.309H7.06c-1.596 0-2.394 0-3.004-.309a2.842 2.842 0 0 1-1.245-1.238c-.311-.606-.311-1.4-.311-2.986v-8.69Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgProgramLibrary;